// @ts-nocheck
import React, {FunctionComponent} from 'react';
import './DrawerPopup.less';
import {useMediaQuery} from 'react-responsive';
import {largeScreenMediaQuery} from 'new-constants/common.constants';
import {Popup} from 'new-components/dialog-layout/popup/Popup';
import {Drawer} from 'new-components/dialog-layout/drawer/Drawer';
import {DialogOverlay} from 'new-components/dialog-layout/dialog-overlay/DialogOverlay';
import {PopupFooter} from 'elements/popup-footer/PopupFooter';
import {DrawerFooter} from 'elements/drawer-footer/DrawerFooter';
import {PopupHeader} from 'compositions/popup-header/PopupHeader.tsx';
import {DrawerHeader} from 'compositions/drawer-header/DrawerHeader.tsx';

export interface DrawerPopupProps {
	title: string;
	description?: string | JSX.Element;
	topStaticControl?: JSX.Element;
	onExternalLinkClick?: () => void;
	onOverlayClick: () => void;
	leftControl?: JSX.Element;
	leftSecondaryControl?: JSX.Element;
	rightControl?: JSX.Element;
	headerBottomControl?: JSX.Element;
	isLoading?: boolean
}

export const DrawerPopup: FunctionComponent<DrawerPopupProps> =
	({
		 title,
		 description,
		 topStaticControl,
		 children,
		 onExternalLinkClick,
		 onOverlayClick,
		 leftControl,
		 leftSecondaryControl,
		 rightControl,
		 headerBottomControl,
		 isLoading
	 }) => {
		const isLargeScreen = useMediaQuery({query: largeScreenMediaQuery});

		if (isLargeScreen) {
			return <DialogOverlay onOverlayClick={isLoading ? () => {
			} : onOverlayClick}>
				<Popup
					topStaticControl={topStaticControl || ((title || description) && (
						<PopupHeader
							title={title}
							description={description}
							bottomControl={headerBottomControl}
							onExternalLinkClick={onExternalLinkClick}
						/>))}
					bottomStaticControl={
						(leftControl || leftSecondaryControl || rightControl) && (<PopupFooter
							leftControl={leftControl}
							leftSecondaryControl={leftSecondaryControl}
							rightControl={rightControl}
						/>)}
					isLoading={isLoading}
				>
					{children}
				</Popup>
			</DialogOverlay>;
		} else {
			return <DialogOverlay onOverlayClick={isLoading ? () => {
			} : onOverlayClick}>
				<Drawer
					onChevronClick={onOverlayClick}
					topStaticControl={topStaticControl || ((title || description) && (
						<DrawerHeader
							title={title}
							description={description}
							bottomControl={headerBottomControl}
							onExternalLinkClick={onExternalLinkClick}
						/>
					))}
					bottomStaticControl={
						(leftControl || leftSecondaryControl || rightControl) && (
							<DrawerFooter
								leftControl={leftControl}
								leftSecondaryControl={leftSecondaryControl}
								rightControl={rightControl}
							/>)
					}
					isLoading={isLoading}
				>
					{children}
				</Drawer>
			</DialogOverlay>;
		}
	};
